module.exports = __webpack_public_path__ + "static/stanModal-16d3cec1cfe3f6734c9cd3a86442a7a9.png";